import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from 'api/analytics';

export default function useGoogleAnalytics() {
	const location = useLocation();

	useEffect(() => {
		analytics.init();
	}, []);

	useEffect(() => {
		const currentPath = location.pathname + location.search;

		console.log('currentPath useGoogleAnalytics', currentPath);
		analytics.sendPageview(currentPath);
	}, [location]);
}
